//export const ServerUrl = "http://127.0.0.1:5000"

export const ServerUrl = "https://ntsendanapi.onrender.com"